import React from 'react';

const SVG = ({
  style = {},
  fill = '#006eaf',
  viewBox = '0 0 24 20.7',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}> 
      <path d="M899.354-77.394a.631.631 0 0 1 .04-.224l3.1-8.174a.634.634 0 0 1 .46-.394l4.314-.915-4.311-.915a.63.63 0 0 1-.46-.393l-3.1-8.175a.633.633 0 0 1 .154-.68.631.631 0 0 1 .685-.126l22.737 9.707a.633.633 0 0 1 .384.581.632.632 0 0 1-.384.581l-22.737 9.706a.629.629 0 0 1-.685-.125.627.627 0 0 1-.197-.454zm4.2-7.627l-2.454 6.464 20.013-8.543-20.013-8.543 2.456 6.465 6.887 1.46a.631.631 0 0 1 .5.618.631.631 0 0 1-.5.618z" transform="translate(-899.354 97.439)"/>
    </g>
  </svg>
);
export default SVG;